var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('successRegister',{staticClass:"mb-3 mt-5 pt-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }